// extracted by mini-css-extract-plugin
module.exports =  {"review":"a10a3f92e9--review--tecPU","review-rate":"a10a3f92e9--review-rate--eLT60","review-text":"a10a3f92e9--review-text--duhdk"};